export default {
  prefix: 'ray-',
  breakpointsInPixels: {
    phone: 0,
    tablet: 600,
    desktop: 1195
  }
};